<template>
    <div>
        <b-field label="Open Sky Agreement carriers"></b-field>
        <b-field class="commonrules-grp my-4">
            <b-radio :native-value="true" :value="allowOpenSkyValue" @input="emitallowOpenSky">
                Allow
            </b-radio>
            <b-radio :native-value="false" :value="allowOpenSkyValue" @input="emitallowOpenSky">
                Do not allow
            </b-radio>
        </b-field>
    </div>
</template>
<script>

export default {
    name: "FlyAmericaStatus",
    props: { allowOpenSkyVal: null },
    data() {
        return {
            allowOpenSkyValue: null,
        }
    },
    methods: {
        emitallowOpenSky(val) {
            this.allowOpenSkyValue = val;
            this.$emit("emitOpenSkyData", val);
        },
    },
    mounted() {
        this.allowOpenSkyValue = this.allowOpenSkyVal;
    }
}
</script>